export default __webpack_public_path__ + "static/media/ClaraFrancesca.6addfa72.jpg";